<template>
  <Modal v-model="editGuideModal" class-name="editGuideStyle" :title="editGuideTitle" width="1000"
    :transfer="false" :mask-closable="false" @on-visible-change="editGuideModalChange">
    <Form :model="editGuideForm" ref="editGuideForm" :rules="ruleValidate" :label-width="100" @submit.native.prevent>
      <Row>
        <Col :xxl="oneItemCol" :xl="oneItemCol" :lg="oneItemCol" :md="oneItemCol">
          <Form-item :label="$t('key1003060')" prop="title">
            <Input v-model.trim="editGuideForm.title" :placeholder="$t('key1003061')" :element-id="'guideTitle'"
              clearable style="width:250px">
            </Input>
          </Form-item>
        </Col>
        <Col :xxl="oneItemCol" :xl="oneItemCol" :lg="oneItemCol" :md="oneItemCol">
          <Form-item :label="$t('key1003062')" prop="moduleName">
            <Select v-model="editGuideForm.moduleName" filterable transfer style="width:250px">
              <Option v-for="(item, index) in systemModuleList" :value="item.name" :key="index">{{ item.name }}</Option>
            </Select>
          </Form-item>
        </Col>
        <Col :xxl="oneItemCol" :xl="oneItemCol" :lg="oneItemCol" :md="oneItemCol">
          <Form-item :label="$t('key1003063')" prop="displayLocation">
            <Select v-model="editGuideForm.displayLocation" filterable transfer style="width:250px">
              <Option v-for="(item, index) in displayLocationList" :value="item.value" :key="index">{{ item.name }}</Option>
            </Select>
          </Form-item>
        </Col>
        <Col :xxl="oneItemCol" :xl="oneItemCol" :lg="oneItemCol" :md="oneItemCol">
          <Form-item :label="$t('key1003064')" prop="type" class="radio_styles">
            <RadioGroup v-model="editGuideForm.type">
              <Radio v-for="(item,index) in guidanceTypeList" :key="index" :label="item.type">{{ item.name }}</Radio>
            </RadioGroup>
          </Form-item>
        </Col>
        <template v-if="editGuideForm.type === 1">
          <Col :xxl="oneItemCol" :xl="oneItemCol" :lg="oneItemCol" :md="oneItemCol">
            <Form-item :label="$t('key1000262')" class="reset_margin required_style_label">
              <div class="flex align-items-center">
                <Upload
                  style="display: inline-block"
                  :headers="headObj"
                  ref="uploadRef"
                  name='files'
                  :show-upload-list="false"
                  :action="uploadAction"
                  :on-success="uploadSuccess"
                  :on-error="uploadError"
                  :on-exceeded-size="uploadExceedSize"
                  :on-format-error="handleFormatError"
                  :max-size="uploadFilesMaxSize"
                  :format="['pdf']">
                  <Button class="mr10">
                    <i class="iconfont mr5">&#xe663;</i>
                    {{ $t('key1000266') }}
                  </Button>
                </Upload>
                <h3 v-if="excleFileName" class="font-size-13 font-weight-bold ml10">{{ excleFileName }}</h3>
              </div>
            </Form-item>
          </Col>
          <Col push="2" :xxl="oneItemCol" :xl="oneItemCol" :lg="oneItemCol" :md="oneItemCol">
            <div class="tips_styles ml20">
              {{ $t('key1000270') }}<br/>
              {{ $t('key1003065') }}<br/>
              {{ $t('key1003066') }}<br/>
            </div>
          </Col>
        </template>
        <!--<Col :xxl="oneItemCol" :xl="oneItemCol" :lg="oneItemCol" :md="oneItemCol" v-if="editGuideForm.type === 2">
                  <Form-item label="站内链接：" prop="moduleName">
                    <Select v-model="editGuideForm.moduleName" filterable transfer style="width:250px">
                      <Option v-for="(item, index) in systemModuleList" :value="item.name" :key="index">{{ item.name }}</Option>
                    </Select>
                  </Form-item>
                </Col>-->
        <Col :xxl="oneItemCol" :xl="oneItemCol" :lg="oneItemCol" :md="oneItemCol" v-if="editGuideForm.type === 3" class="editor_style">
          <Form-item :label="$t('key1003033')" prop="content" label-position="top" class="required_style_label">
            <UE
              :disabled="false"
              :content.sync="editGuideForm.content || ''"
              :htmlStatus="false"
              id="editGuideForm.add.description"
              :config=config
              ref="ueBox">
            </UE>
          </Form-item>
        </Col>
        <Col :xxl="oneItemCol" :xl="oneItemCol" :lg="oneItemCol" :md="oneItemCol">
          <Form-item :label="$t('key1003034')" prop="sortNo">
            <InputNumber :max="9999999" :min="1" v-model="editGuideForm.sortNo" :formatter="value => `${parseInt(value)}`"
              style="width: 250px">
            </InputNumber>
          </Form-item>
        </Col>
        <Col :xxl="oneItemCol" :xl="oneItemCol" :lg="oneItemCol" :md="oneItemCol">
          <Form-item :label="$t('key1001522')" prop="status" class="radio_styles">
            <RadioGroup v-model="editGuideForm.status">
              <Radio :label="1">{{ $t('key1000462') }}</Radio>
              <Radio :label="0">{{ $t('key1000463') }}</Radio>
            </RadioGroup>
          </Form-item>
        </Col>
      </Row>
    </Form>
    <template #footer>
      <Button @click="editGuideModal = false">{{ $t('key1000248') }}</Button>
      <Button type="primary" @click="editGuideBtn">{{ $t('key1000555') }}</Button>
    </template>
  </Modal>
</template>

<script>
import aliasb03645cf6abd4d56a73b13687765a5d8 from '@/locale/i18nUtils.js';

import api from '@/api/';
import Mixin from "@/components/mixin/common_mixin";
import UE from "@/components/common/ue.vue";
import supplierMenu from "@/config/menu/supplier";
import {getDataSetBatchList, getEnumList, getSystemModuleList} from "@/utils/common";

export default {
  name: "editGuideModal",
  components: {UE},
  mixins: [Mixin],
  data() {
    let v = this;
    return {
      editGuideModal: false,
      editGuideTitle: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1003012'),
      editGuideForm: {
        title: '',
        moduleName: '',
        type: 1,
        sortNo: 1,
        displayLocation: null,
        content: '',
        status: 1,
      },
      ruleValidate: {
        title: [
          {required: true, message: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1003053'), trigger: 'blur'}
        ],
        moduleName: [
          {required: true, message: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1003054'), trigger: 'change'}
        ],
        displayLocation: [
          {required: true, message: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1003055'), trigger: 'change', type: 'number'}
        ],

      },
      guidanceTypeList: [],
      systemModuleList: [],
      systemType: null, // 1分销商系统  2运营系统  3供应商系统
      uploadAction: api.erpCommon_uploadFiles + '?basePath=yms-core-service&action="uploadimage"',
      excleFileName: null,
      editGuideType: 'add',
      config: { // 富文本编辑器 配置
        initialFrameWidth: null,
        initialFrameHeight: 380,
        serverUrl: api.get_erpCommon_ueditorEnter,
        wordCount: false,
        autoHeightEnabled: false,
        imageScaleEnabled: false,
        elementPathEnabled: false, // 禁止显示元素路径
      },
      ymsOperatingInstructionsId: null,
      uploadFilesUrl: '',
      enumData: []
    };
  },
  computed: {
    // 显示位置
    displayLocationList() {
      const ENUM_KEY = 'YmsOperatingInstructionsDisplayLocationCoreEnum';
      return getEnumList(this.enumData, ENUM_KEY, 'number');
    }
  },
  methods: {
    // 初始化数据
    async initGuideData(type, systemType, guidanceTypeList, ymsOperatingInstructionsId) {
      let obj = {
        add: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1003012'),
        edit: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1003056')
      };
      let enumKeyList = ['YmsOperatingInstructionsDisplayLocationCoreEnum'];
      this.enumData = await getDataSetBatchList(enumKeyList);
      this.systemModuleList = getSystemModuleList(supplierMenu, systemType);
      this.guidanceTypeList = guidanceTypeList;
      this.systemType = Number(systemType);
      this.editGuideType = type;
      this.editGuideTitle = obj[type];
      this.ymsOperatingInstructionsId = ymsOperatingInstructionsId;
      if (type === 'add') {
        this.editGuideModal = true;
      } else {
        this.getGuideDetails(ymsOperatingInstructionsId);
      }
    },
    // 获取指引详情数据
    getGuideDetails(ymsOperatingInstructionsId) {
      this.axios.get(api.get_ymsOperatingInstructions_detail + ymsOperatingInstructionsId, null, {loading: true}).then((res) => {
        this.editGuideModal = true;
        if (res.data.code === 0) {
          let data = res.data.datas;
          if (data) {
            for (let key in this.editGuideForm) {
              this.editGuideForm[key] = data[key];
            }
            if (data.type === 1) {
              this.excleFileName = data.content;
              this.uploadFilesUrl = data.content;
              this.editGuideForm.content = '';
            } else if (data.type === 3) {
              this.$refs.ueBox.setUEContent(data.content);
            }
          }
        }
      });
    },

    // 上传文件失败
    uploadError() {
      this.$Message.error(aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000250'));
      return false;
    },
    // 控制上传图片大小
    uploadExceedSize() {
      this.$Message.error(aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000138'));
      return false;
    },
    // 上传文件成功
    uploadSuccess(response, file, fileList) {
      let v = this;
      if (response.code === 0) {
        this.excleFileName = file.name;
        v.uploadFilesUrl = response.datas[0];
        v.$Message.success(aliasb03645cf6abd4d56a73b13687765a5d8.t('key1003057'));
      }
    },
    // 保存按钮
    editGuideBtn() {
      let v = this;
      let text = '';
      let url = '';
      let method = '';
      let params = {
        content: '',
        displayLocation: v.editGuideForm.displayLocation,
        moduleName: v.editGuideForm.moduleName,
        sortNo: v.editGuideForm.sortNo,
        status: v.editGuideForm.status,
        systemType: v.systemType,
        title: v.editGuideForm.title,
        type: v.editGuideForm.type
      };
      switch (v.editGuideForm.type) {
        case 1:
          params.content = v.uploadFilesUrl;
          break;
        case 3:
          params.content = v.$refs.ueBox.getUEContent();
          break;
      }
      if (v.editGuideType === 'add') {
        url = api.post_ymsOperatingInstructions_save;
        method = 'post';
        text = aliasb03645cf6abd4d56a73b13687765a5d8.t('key1001488');
      } else if (v.editGuideType === 'edit') {
        url = api.put_ymsOperatingInstructions;
        method = 'put';
        text = aliasb03645cf6abd4d56a73b13687765a5d8.t('key1002279');
        params.ymsOperatingInstructionsId = v.ymsOperatingInstructionsId;
      }
      v.$refs['editGuideForm'].validate((valid) => {
        if (valid) {
          if (!params.content) {
            switch (v.editGuideForm.type) {
              case 1:
                v.$Message.warning(aliasb03645cf6abd4d56a73b13687765a5d8.t('key1003058'));
                break;
              case 3:
                v.$Message.warning(aliasb03645cf6abd4d56a73b13687765a5d8.t('key1003059'));
                break;
            }
          } else {
            v.axios[method](url, params, {loading: true, loadingText: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000247')}).then(response => {
              if (response.data.code === 0) {
                v.$Message.success(text);
                v.editGuideModal = false;
                v.$emit('updateData', true);
              }
            });
          }
        }
      });
    },
    // 监听弹窗
    editGuideModalChange(value) {
      let v = this;
      if (!value) {
        v.uploadFilesUrl = '';
        v.editGuideForm.content = '';
        v.systemType = null;
        v.excleFileName = null;
        v.ymsOperatingInstructionsId = null;
        if (v.$refs.ueBox) {
          v.$refs.ueBox.setUEContent('');
        }
        v.$nextTick(() => {
          v.$refs['editGuideForm'].resetFields();
        });
      } else {
        v.$nextTick(() => {
          if (v.editGuideType === 'add') {
            v.$refs['editGuideForm'].resetFields();
          }
          setTimeout(() => {
            v.getFocus('guideTitle');
          }, 800);
        });
      }
    }
  },
  watch: {
    'editGuideForm.type': {
      handler(val) {
        let v = this;
        if (val === 3) {
          v.$nextTick(() => {
            let editor = v.$refs['ueBox'].editor;
            let userInfo = v.$store.state.erpConfig.userInfo;
            editor.addListener('ready', function () {
              editor.execCommand('serverparam', {
                'basePath': 'yms-core-service',
                'userId': userInfo.merchantId + ',' + userInfo.userId
              });
            });
          });
        }
      }
    }
  }
};
</script>

<style lang="less" scoped>
.editGuideStyle {
  .reset_margin {
    margin-bottom: 8px !important;
  }

  .tips_styles {
    color: #9a9797;
    margin: 10px 0 20px 0;
  }

  .editor_style {
    /deep/ .ivu-form-item-content {
      line-height: initial !important;
    }
  }
}

/deep/ .ivu-modal-wrap {
  z-index: 1001 !important;
}

/deep/ .ivu-modal-mask {
  z-index: 1001 !important;
}
</style>
